import { Typography } from '@mui/material';
import { styled } from '@mui/system';

export const InfoTagContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

interface IconContainerProps {
  backgroundColor: string;
  iconColor: string;
}

export const IconContainer = styled('div', {
  shouldForwardProp: (prop) =>
    prop !== 'backgroundColor' && prop !== 'iconColor',
})<IconContainerProps>(({ backgroundColor, iconColor }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '100%',
  width: '26px',
  height: '26px',
  backgroundColor,
  svg: {
    color: iconColor,
    fontSize: '19px',
  },
}));

export const ContentContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
}));

interface InfoTagTitleProps {
  color: string;
}

export const InfoTagTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<InfoTagTitleProps>(({ color }) => ({
  color,
  fontSize: '14px',
  fontWeight: 300,
}));

export const InfoTagContent = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 400,
  color: theme.palette.text.secondary,
}));

export const Strong = styled('span')({
  fontWeight: 600,
});
